const schema = () => ({
  type: 'object',
  required: [],
  properties: {
    vehicle_ids: {
      type: 'array',
      title: 'vehicle',
      items: [],
    },
    site_ids: {
      type: 'array',
      title: 'site',
      items: [],
    },
    workshop_ids: {
      type: 'array',
      title: 'workshop',
      items: [],
    },
    driver_ids: {
      type: 'array',
      title: 'driver',
      items: [],
    },
    type_ids: {
      type: 'array',
      title: 'task_type',
      default: undefined,
      // oneOf: taskTypes,
      items: [],
    },

    material_type_ids: {
      type: 'array',
      title: 'material_type',
      // oneOf: materialTypes,
      items: [],
    },
    shift_type_ids: {
      type: 'string',
      title: 'shift_type',
      // oneOf: shiftTypes,
    },
    operation_type_ids: {
      type: 'array',
      title: 'operation',
      // oneOf: operationTypes,
      items: [],
    },
    status_ids: {
      type: 'array',
      title: 'task_status',
      default: undefined,
      // oneOf: taskStatuses,
      items: [],
    },
    min_created_at: {
      type: 'string',
      title: 'start_date',
      format: 'date',
    },
    max_created_at: {
      type: 'string',
      title: 'end_date',
      format: 'date',
    },
    start_time: {
      type: 'string',
      title: 'start_time',
      // format: 'time',
    },
    end_time: {
      type: 'string',
      title: 'end_time',
      // format: 'time',
    },
    // match_location: {
    //   type: 'string',
    //   title: 'match_location',
    //   default: undefined,
    //   oneOf: [
    //     { const: '1', title: 'do' },
    //     { const: '0', title: 'dont' },
    //   ],
    // },
    supervisor_ids: {
      type: 'array',
      title: 'supervisor',
      items: [],
    },
    vehicle_type_ids: {
      type: 'array',
      title: 'vehicle_type',
      items: [],
    },
  },
});

export default schema;
